export var PillSize;
(function (PillSize) {
    PillSize[PillSize["compact"] = 0] = "compact";
    PillSize[PillSize["regular"] = 1] = "regular";
    PillSize[PillSize["large"] = 2] = "large";
})(PillSize || (PillSize = {}));
export var PillVariant;
(function (PillVariant) {
    PillVariant[PillVariant["standard"] = 0] = "standard";
    PillVariant[PillVariant["outlined"] = 1] = "outlined";
    PillVariant[PillVariant["colored"] = 2] = "colored";
    PillVariant[PillVariant["themedStandard"] = 3] = "themedStandard";
})(PillVariant || (PillVariant = {}));
